/** Employee roles that can view the surgery booking admin dash (read-only). */
export const SURGERY_BOOKING_READ_EMP_ROLES: readonly string[] = [
  "Captain",
  "Executive",
  "Developer",
];

/** Employee roles that can mutate surgery booking admin data. */
export const SURGERY_BOOKING_WRITE_EMP_ROLES: readonly string[] = [
  "CRM",
  "Admin",
  "Super Admin",
];

const normalize = (role?: string | null) => String(role || "").trim();

/**
 * Admin surgery-slots dash is available to:
 * - Super Admin portal (always)
 * - Operations portal
 * - Production portal when a Captain or Admin employee is logged in
 */
export const canAccessSurgeryBookingAdmin = (
  portalRole?: string | null,
  empRole?: string | null,
) => {
  if (portalRole === "Super Admin") return true;
  if (portalRole === "Operations") return true;
  if (portalRole === "Production") {
    const role = normalize(empRole);
    return role === "Captain" || role === "Admin";
  }
  return false;
};

/** Portal Super Admin always writes; otherwise employee must be CRM / Admin / Super Admin. */
export const canWriteSurgeryBooking = (
  portalRole?: string | null,
  empRole?: string | null,
) => {
  if (portalRole === "Super Admin") return true;
  return SURGERY_BOOKING_WRITE_EMP_ROLES.includes(normalize(empRole));
};

export const canReadSurgeryBookingAdmin = (
  portalRole?: string | null,
  empRole?: string | null,
) => {
  if (!canAccessSurgeryBookingAdmin(portalRole, empRole)) return false;
  if (portalRole === "Super Admin") return true;
  const role = normalize(empRole);
  return (
    SURGERY_BOOKING_WRITE_EMP_ROLES.includes(role) ||
    SURGERY_BOOKING_READ_EMP_ROLES.includes(role) ||
    // Operations staff without a specialized role still get view access
    portalRole === "Operations"
  );
};
